import React from 'react';
import styles from './Field.module.css';
import { Field, useField } from 'formik';
import { ReactComponent as RadioOnIcon } from '../../icons/radio_on.svg';
import { ReactComponent as RadioOffIcon } from '../../icons/radio_off.svg';


const FieldRadio = ({ label, name, id = name, onChange, value }) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                const isChecked = form.values[name] === value;

                return (
                    <label className={styles.radio}>
                        <input type="radio" {...field} value={value} checked={isChecked} style={{ display: 'none' }} />
                        {isChecked ? <RadioOnIcon /> : <RadioOffIcon />}
                        {' '}{label}
                    </label>
                );
            }}
        </Field>
    );
};

export default FieldRadio;
